import React from 'react';
import { Close } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';

interface IProps {
  title: string;
  content: React.ReactNode;
  open: boolean;
  close: () => void;
  handleConfirm: () => void;
}

export default function ConfirmDialog(props: IProps) {
  const { title, content, open, close, handleConfirm } = props;

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button color="inherit" variant="contained" onClick={close}>
          キャンセル
        </Button>
        <Button color="error" variant="contained" onClick={handleConfirm}>
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
}
